import React, { Component } from "react";
import PropTypes from "prop-types";

import { SelectItem, ConfirmInlineButton } from "app/NativeComponents/snippets";

import { formatPhoneNumber, renderDate } from "app/NativeActions";

class NeverCallListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  render() {
    const { item, onRemove } = this.props;

    return (
      <SelectItem
        select_type={"none"}
        loading={this.state.loading}
        subtext={renderDate(item.created_at)}
        renderRight={() => {
          return (
            <ConfirmInlineButton
              button_type="normal"
              style={{ flexShrink: 1, paddingLeft: 10, paddingRight: 10 }}
              textStyle={{ whiteSpace: "normal" }}
              confirm_text="Really Remove?"
              confirm_icon="delete"
              loading_text="Removing"
              loading={this.state.loading}
              onPress={() => {
                this.props.removePhoneNumberFromNeverCallList({
                  token: this.props.token,
                  phone_number: item.phone_number,
                  onLoading: () => {
                    this.setState({ loading: true });
                  },
                  onError: () => {
                    this.setState({ loading: false });
                  },
                  onSuccess: () => {
                    this.setState({ loading: false });
                    this.props.onRemove(item);
                  }
                });
              }}
            >
              {!this.props.isMobile ? "Remove from never call list":"Remove"}
            </ConfirmInlineButton>
          );
        }}
        noPress={true}
        description={
          item.contact
            ? item.contact.given_name + " " + item.contact.surname
            : null
        }
      >
        {formatPhoneNumber(item.phone_number)}
      </SelectItem>
    );
  }
}

NeverCallListItem.propTypes = {
  item: PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  onRemove: PropTypes.func.isRequired
};

export default NeverCallListItem;
